import { Toaster as Sonner } from "sonner"
import "./sonner.css"

function Toaster() {
  return (
    <Sonner
      position="top-center"
      expand={false}
      closeButton={false}
      richColors={false}
      className="toaster"
      toastOptions={{
        classNames: {
          toast: "toast",
          title: "toast-title",
          description: "toast-description",
          icon: "toast-icon",
        },
      }}
    />
  )
}

export { Toaster }

export { toast } from "sonner"
